export const SHOW_AUCTION_DOC_DIALOG = '@auctionDocument/SHOW_AUCTION_DOC_DIALOG';